module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_7005.cea6b17b.png";